import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HoraDeAtendimentoDTO, HoraDeAtendimentoResponseDTO } from '../../models/hora-de-atendimento.models';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class HoraDeAtendimentoService {
  private baseUrl = '/horaDeAtendimento';

  constructor(private apiService: ApiService) { }

  get(url: string, data?: any): Observable<HoraDeAtendimentoResponseDTO> {
    const queryParams = this.apiService.buildQueryParams(data);
    const path = queryParams ? `${url}?${queryParams}` : url;

    return this.apiService.read<HoraDeAtendimentoResponseDTO>(path);
  }

  getById<T>(url: string): Observable<HoraDeAtendimentoResponseDTO> {
    return this.apiService.read<HoraDeAtendimentoResponseDTO>(url);
  }

  post<T>(
    url: string,
    data: HoraDeAtendimentoDTO | undefined
  ): Observable<HoraDeAtendimentoDTO> {
    return this.apiService.create<HoraDeAtendimentoDTO>(url, data);
  }

  put<T>(
    url: string,
    data: HoraDeAtendimentoDTO
  ): Observable<HoraDeAtendimentoDTO> {
    return this.apiService.update<HoraDeAtendimentoDTO>(url, data);
  }

  delete<T>(url: string): Observable<any> {
    return this.apiService.delete(url);
  }

}
